// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "../Utilities/LoggerUtils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";

function PaymentDropDownField(props) {
  var __className = props.className;
  var __disabled = props.disabled;
  var options = props.options;
  var fieldName = props.fieldName;
  var setValue = props.setValue;
  var value = props.value;
  var disabled = __disabled !== undefined ? __disabled : false;
  var className = __className !== undefined ? __className : "";
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var config = match.config;
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match$1.localeString;
  var themeObj = match$1.themeObj;
  var match$2 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var loggerState = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  var dropdownRef = React.useRef(null);
  var match$3 = React.useState(function () {
        return false;
      });
  var setInputFocused = match$3[1];
  var inputFocused = match$3[0];
  var match$4 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var parentURL = match$4.parentURL;
  var isSpacedInnerLayout = config.appearance.innerLayout === "Spaced";
  var getClassName = function (initialLabel) {
    if (value.value.length === 0) {
      return initialLabel + "--empty";
    }
    var valid = value.isValid;
    if (valid !== undefined) {
      if (valid) {
        return initialLabel + "--valid";
      } else {
        return initialLabel + "--invalid";
      }
    } else {
      return "";
    }
  };
  React.useEffect((function () {
          var initialValue = Core__Option.getOr(options[0], "");
          if (value.value === "" || !options.includes(value.value)) {
            setValue(function (param) {
                  return {
                          value: initialValue,
                          isValid: true,
                          errorString: ""
                        };
                });
          }
          
        }), [options]);
  var handleFocus = function (param) {
    setInputFocused(function (param) {
          return true;
        });
    Utils$OrcaPaymentPage.handleOnFocusPostMessage(parentURL);
  };
  var focusClass = inputFocused || value.value.length > 0 ? "mb-7 pb-1 pt-2 " + themeObj.fontSizeXs + " transition-all ease-in duration-75" : "transition-all ease-in duration-75";
  var floatinglabelClass = inputFocused ? "Label--floating" : "Label--resting";
  var labelClass = getClassName("Label");
  var inputClass = getClassName("Input");
  var inputClassStyles = isSpacedInnerLayout ? "Input" : "Input-Compressed";
  var handleChange = function (ev) {
    var target = ev.target;
    var value = target.value;
    if (fieldName.length > 0) {
      LoggerUtils$OrcaPaymentPage.logInputChangeInfo(fieldName, loggerState);
    }
    setValue(function (param) {
          return {
                  value: value,
                  isValid: true,
                  errorString: ""
                };
        });
  };
  var disbaledBG = React.useMemo((function () {
          return themeObj.colorBackground;
        }), [themeObj]);
  var cursorClass = disabled ? "cursor-not-allowed" : "cursor-pointer";
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: options.length > 0,
              children: React.createElement("div", {
                    className: "flex flex-col w-full",
                    style: {
                      color: themeObj.colorText
                    }
                  }, React.createElement(RenderIf$OrcaPaymentPage.make, {
                        condition: fieldName.length > 0 && config.appearance.labels === "Above" && isSpacedInnerLayout,
                        children: React.createElement("div", {
                              "aria-hidden": true,
                              className: "Label " + labelClass + " ",
                              style: {
                                fontSize: themeObj.fontSizeLg,
                                fontWeight: themeObj.fontWeightNormal,
                                marginBottom: "5px",
                                opacity: "0.6"
                              }
                            }, fieldName)
                      }), React.createElement("div", {
                        className: "relative"
                      }, React.createElement("select", {
                            ref: Caml_option.some(dropdownRef),
                            "aria-label": fieldName + " option tab",
                            className: inputClassStyles + " " + inputClass + " " + className + " w-full appearance-none outline-none overflow-hidden whitespace-nowrap text-ellipsis " + cursorClass,
                            style: {
                              background: disabled ? disbaledBG : themeObj.colorBackground,
                              padding: "11px 22px 11px 11px",
                              width: "100%",
                              opacity: disabled ? "35%" : ""
                            },
                            disabled: match$2.readOnly || disabled,
                            name: "",
                            value: value.value,
                            onFocus: handleFocus,
                            onChange: handleChange
                          }, options.map(function (item, i) {
                                return React.createElement("option", {
                                            key: i.toString(),
                                            value: item
                                          }, item);
                              })), React.createElement(RenderIf$OrcaPaymentPage.make, {
                            condition: config.appearance.labels === "Floating",
                            children: React.createElement("div", {
                                  "aria-hidden": true,
                                  className: "Label " + floatinglabelClass + " " + labelClass + " absolute bottom-0 ml-3 " + focusClass + " pointer-events-none",
                                  style: {
                                    fontSize: inputFocused || value.value.length > 0 ? themeObj.fontSizeXs : "",
                                    marginBottom: inputFocused || value.value.length > 0 ? "" : themeObj.spacingUnit,
                                    opacity: "0.6"
                                  }
                                }, fieldName)
                          }), React.createElement("div", {
                            className: "self-center absolute",
                            style: {
                              color: themeObj.colorText,
                              left: localeString.localeDirection === "rtl" ? "1%" : "97%",
                              marginLeft: localeString.localeDirection === "rtl" ? "1rem" : "-1rem",
                              top: "42%",
                              opacity: disabled ? "35%" : ""
                            }
                          }, React.createElement(Icon$OrcaPaymentPage.make, {
                                name: "arrow-down",
                                size: 10
                              })), React.createElement(RenderIf$OrcaPaymentPage.make, {
                            condition: value.errorString.length > 0,
                            children: React.createElement("div", {
                                  className: "Error pt-1",
                                  style: {
                                    color: themeObj.colorDangerText,
                                    fontSize: themeObj.fontSizeSm,
                                    textAlign: "left",
                                    alignSelf: "start"
                                  }
                                }, value.errorString)
                          })))
            });
}

var make = PaymentDropDownField;

export {
  make ,
}
/* react Not a pure module */
